/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  getOustandingDisputesNumDaysResult,
  setOutstandingDisputesNumOfDays,
  setSearchInput,
} from '../Store/actions';
import { REBATE_SELECT } from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';

export default function ReqOutstandingDisputesNumOfDays(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    // selectedPlanType,
    // rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    // allRebateProgram: allRebateProgramValue,
    searchResult,
    // numOfDays: numOfDaysValue,
    searchScreenVar: {
      rebateProgramValue,
      selectedPlanType,
      numOfDays: numOfDaysValue,
      allRebateProgram: allRebateProgramValue,
    },
  } = useSelector(
    (state) => state?.sharedState?.OutstandingDisputesNumOfDaysReducer
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );

  // To know that search button is pressed
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [errorList, setErrorList] = React.useState(errors);
  const [allRebateProgram, setAllRebateProgram] = React.useState(
    allRebateProgramValue
  );
  const [numOfDays, setNumOfDays] = React.useState(numOfDaysValue);

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
          disabled: allRebateProgram,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList, allRebateProgram]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData?.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    if (list?.length) {
      setSelectList(list);
      const tempRebateProgram = list.find(
        (item) => item.id === userDefaults?.rebateProgramCd
      );
      setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
      setRebateProgramName(tempRebateProgram?.name || '');
    }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  const validateInputs = () => {
    const localErrors = [];
    const regex = /^[1-9][0-9]*$/;
    if (numOfDays?.trim().length === 0) {
      localErrors.push({
        field: 'numOfDays',
        message: 'Please Enter number of Days.',
      });
    }
    if (numOfDays?.trim().length > 0) {
      if (!regex.test(numOfDays)) {
        localErrors.push({
          field: 'numOfDays',
          message: 'Please Enter valid Number.',
        });
      }
    }
    return localErrors;
  };
  // handing highlight tab
  React.useEffect(() => {
    if (errorList?.length > 0) {
      tabHighLigther('/outstandingDisputesForNumOfDays', true);
    } else {
      tabHighLigther('/outstandingDisputesForNumOfDays', false);
    }
  }, [JSON.stringify(errorList)]);
                
  // remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [allRebateProgram, planType, rebateProgram, ,]);
  
  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen
  const handleSearchClick = () => {
    let allErrors = [];
    const localErrors = validateInputs();
    // setErrorList(localErrors);
    if (rebateProgram === '-1' && allRebateProgram === false) {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }

    allErrors = [...allErrors, ...errorList, ...localErrors];

    setErrorList(allErrors);
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList?.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;

    dispatch(
      setSearchInput({
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        rebateProgramName,
        allRebateProgram,
        rebateProgrameName,
        numOfDays,
        searchScreenVar: {
          rebateProgrameName,
          rebateProgramValue: rebateProgram,
          selectedPlanType: planType,
          numOfDays,
          allRebateProgram,
        },
      })
    );

    if (allErrors.length === 0) {
      dispatch(setOutstandingDisputesNumOfDays([]));
      setSearchClicked(true);
      dispatch(
        getOustandingDisputesNumDaysResult({
          asRpc: allRebateProgram ? 'ALL' : rebateProgram,
          anAll: allRebateProgram ? '1' : '0',
          num: numOfDays,
        })
      );
    }
  };

  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/dispOutstandingDisputeNumOfDays',
      value: 'Display Outstanding Disputes After Num of Days',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props.history) {
      props.history.push({
        pathname: '/dispOutstandingDisputeNumOfDays',
      });
    }
    dispatch(clearReduxForFilterAndSort('/dispOutstandingDisputeNumOfDays'));
  }

  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  // Change undo
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Outstanding Disputes After Num of Days"
      />
      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      <div className="tab-body custom-search-dates">
        <div className="row mb-3">
          <div className="col-4 ml-4 mt-2">
            <FormControlLabel
              control={
                <Checkbox
                  // defaultChecked
                  checked={allRebateProgram}
                  color="primary"
                  name="allRebateProgram"
                  onBlur={() => {}}
                  onChange={() => {
                    setAllRebateProgram(!allRebateProgram);
                    const tempRadioList = radioList?.map((item) => {
                      return { ...item, disabled: !allRebateProgram };
                    });
                    setRadioList(tempRadioList);
                    if (!allRebateProgram) {
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }
                  }}
                />
              }
              label="All Rebate Programs"
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="OutstandingNumOfDays-PlanType"
              id="filter-plan-by-radio-btn-action"
              labelName="Plan Type"
              required
              optionList={radioList || []}
              defaultValue={planType}
              filterAction={(value) => {
                setPlanType(value);
                setRebateProgram('-1');

                const errors = errorList.filter(
                  (error) => error.field !== 'rebateProgram'
                );
                setErrorList([...errors]);
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-4">
            <>
              <Fieldset label="Rebate Program" required>
                <div>
                  <SelectBoxComponent
                    disabled={allRebateProgram}
                    data-testid="OutstandingNumOfDays-RebateProgram"
                    id="filter-plan-by-radio-btn-action"
                    labelName="Rebate Program"
                    required
                    select
                    selectOne
                    optionList={selectList || []}
                    defaultValue={rebateProgram}
                    filterAction={(value) => {
                      setRebateProgram(value);
                      setRebateProgramName(value);
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'rebateProgram')
                        ?.message
                    }
                  />
                </div>
              </Fieldset>
            </>
          </div>
          <div className="col-3 mui-custom-form input-md field-xl mt-3">
            <TextField
              label="Outstanding Disputes After
                                    Days"
              id="Outstanding Disputes After
              Days"
              data-testid="outstandingDisputesAfterNumOdDays"
              placeholder=""
              InputLabelProps={{
                shrink: true,
              }}
              required
              value={numOfDays}
              onChange={(e) => {
                setNumOfDays(e.target.value);
                setErrorList([]);
              }}
              onBlur={() => setErrorList(validateInputs())}
              error={
                errorList.filter((error) => error.field === 'numOfDays')
                  ?.length > 0
                  ? 'mandate-fields'
                  : ''
              }
              helperText={
                errorList.find((error) => error.field === 'numOfDays')?.message
              }
              className="mandate-fields"
            />
          </div>
        </div>
        <div className="float-right mt-2 hide-on-print mr-4">
          <Button
            className="btn-success same-font-family"
            data-tesid="view_detail_ia"
            onClick={() => handleSearchClick()}
          >
            <SVGComponent iconName="Icon-search" /> {' Search'}
          </Button>
        </div>
      </div>
    </div>
  );
}
